DialogListasCompartirCtrl.$inject = ['$log', '$scope', '$http', '$q'];
export default function DialogListasCompartirCtrl($log, $scope, $http, $q) {
    var vm = this;

    vm.model = $scope.model;
    vm.dialogHandler = $scope.dialog;
    vm.cargando = {
        datos: true,
        submit: false
    };

    var urlBase = Sigo.var.path + '/api/v1/listas-compartir';

    vm.formDeshabilitado = true;
    vm.modoEdicion = false;
    vm.reparadores = null;

    vm.usuarios = [];
    vm.usuariosRestantes = [];
    vm.usuario_lista = null;
    init();

    function init() {
        var promesas = [];
        promesas.push(cargarUsuarios(vm.model.listaId));
        $q.all(promesas).then(function () {
            vm.formDeshabilitado = false;
            vm.cargando.datos = false;
        });
    }

    function cargarUsuarios(listaId) {
        var url = urlBase + '/' + listaId;
        var promesa = $http.get(url);
        promesa.then(function (respuesta) {
            vm.usuarios = respuesta.data.usuarios_lista;
            vm.usuariosRestantes = respuesta.data.usuarios_no_lista;
            vm.usuarioIdLista = respuesta.data.id_usuario_lista
        }, function (err) {
            $log.error('Error');
        });
        return promesa;
    }

    vm.renderUsuario = function (usuario) {
        return usuario.codusuario + ' (' + usuario.nombre + ' ' + usuario.apellidos + ')';
    };

    vm.anyadirUsuario = anyadirUsuario;

    function anyadirUsuario(usuario, listaId) {
        vm.formDeshabilitado = true;
        vm.cargando.submit = true;
        var url = urlBase + '/' + listaId + '/add/' + usuario.id;
        var data = {usuario_id: usuario.id};
        var promesa = $http.post(url, data);
        promesa.then(function (respuesta) {
            vm.usuarios = respuesta.data.usuarios_lista;
            vm.usuariosRestantes = respuesta.data.usuarios_no_lista;
            vm.formDeshabilitado = false;
            vm.cargando.submit = false;
        }, function (err) {
            $log.error('Error');
            vm.formDeshabilitado = false;
            vm.cargando.submit = false;
            respuestaErronea(err);
        });
        return promesa;
    }

    vm.eliminarUsuario = eliminarUsuario;

    function eliminarUsuario(usuario, listaId) {
        vm.formDeshabilitado = true;
        vm.cargando.submit = true;
        var url = urlBase + '/' + listaId + '/remove/' + usuario.id;
        var promesa = $http.post(url);
        promesa.then(function (respuesta) {
            vm.usuarios = respuesta.data.usuarios_lista;
            vm.usuariosRestantes = respuesta.data.usuarios_no_lista;
            vm.formDeshabilitado = false;
            vm.cargando.submit = false;
        }, function (err) {
            $log.error('Error');
            vm.formDeshabilitado = false;
            vm.cargando.submit = false;
        });
        return promesa;
    }

    vm.cerrar = function () {
        vm.dialogHandler.cancel();
    }
}